import { activeCart } from '@/services/checkout';
import { setCookie } from 'cookies-next';

export function decodeJwt(token, fromServer = true) {
  if (!token) {
    return;
  }
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  if (!fromServer) {
    return JSON.parse(window.atob(base64));
  } else {
    return JSON.parse(Buffer.from(base64, 'base64').toString());
  }
}

export function formatDateString(input, lang) {
  // Convert input to ISO format
  const date = new Date(input.replace(' ', 'T'));

  // Format date as "DD Mon YYYY"
  return new Intl.DateTimeFormat(lang == 'en' ? 'en-GB' : 'ar-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(date);
}

export const sortJSONKeys = (values) => values?.some(item => 'position' in item) ? values?.sort((a, b) => Number(a?.position) - Number(b?.position)) : values

export function findObjectByIdV2(data, targetKey, searchValue) {
  if (data && Array.isArray(data) && data?.length) {
    for (const item of data) {
      if (item[targetKey] == searchValue) {
        // prettyConole(searchValue, item)
        return item;
      }

      if (item?.children_data && item?.children_data.length > 0) {
        const result = findObjectByIdV2(
          item?.children_data,
          targetKey,
          searchValue
        );
        if (result) {
          // prettyConole(searchValue, result)
          return result;
        }
      }
    }
  }
  // Target object not found
  return null;
}

export function clearFalsyKeysFromObject(obj) {
  const filteredObj = {};

  for (const key in obj) {
    const value = obj[key];

    if (value === null || value === undefined) continue;

    if (typeof value === 'string' && value.trim() === '') continue;

    filteredObj[key] = value;
  }

  return filteredObj;
}

export const getFullImagePath = (path) => {
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  if (path.startsWith('/')) {
    path = path.slice(1);
  }
  const imagePath = `${process.env.NEXT_PUBLIC_IMG_BASEURL}/${path}`;

  return imagePath;
};

export function findObjectById(data, targetKey, searchValue) {
  if (data?.length) {
    for (const item of data) {
      if (item[targetKey] == searchValue) {
        return item;
      }
      if (item?.children_data && item?.children_data.length > 0) {
        const result = findObjectById(
          item?.children_data,
          targetKey,
          searchValue
        );
        if (result) {
          return result;
        }
      }
    }
  }
  return null;
}

export const modifyMenuTreeData = (
  array,
  parentURL = '',
  parentBreadcrumb = []
) => {
  return (array || [])
    .filter(
      (cat) =>
        cat.is_active && cat.include_in_menu === '1' && cat.product_count > 0
    )
    .map((cat) => {
      // Set currentURL for each category
      const currentURL = `${parentURL}/${cat.url_key}`;

      // Build up the breadcrumb path
      const breadcrumb = [
        ...parentBreadcrumb,
        {
          name: cat.name,
          url: currentURL,
        },
      ];

      const modifiedCategory = {
        ...cat,
        currentURL,
        breadcrumb,
      };

      // If there are children, apply recursion to include them
      if (cat.children_data?.length) {
        modifiedCategory.children_data = modifyMenuTreeData(
          cat.children_data,
          currentURL,
          breadcrumb
        );
      }

      return modifiedCategory;
    });
};

export const handleLinkByType = (link, type) => {
  switch (type) {
    case 'url':
      return link;
    case 'product':
      return link?.startsWith('/product/') ? link : `/product/${link}`;
    case 'category':
      return link?.startsWith('/') ? link?.slice(0) : `/${link}`;
    default:
      return ``;
  }
};

export const handleMiddlewareSegments = (
  request,
  requiredLocale,
  currentLocale
) => {
  const url = request.nextUrl.clone();
  const { pathname } = request.nextUrl;

  const segments = pathname.split('/').filter((segment) => segment !== '');

  if (segments.length >= 1) {
    url.pathname = `/${requiredLocale}/${segments[0].toLocaleLowerCase() === currentLocale ? segments.slice(1).join('/') : segments.join('/')}`;
  } else {
    url.pathname = `/${requiredLocale}`;
  }

  return url;
};

export const iconsClass = {
  width: '25px',
  height: '25px',
  backgroundImage: `url(https://maps.gstatic.com/mapfiles/embed/images/entity11.png)`,
  backgroundSize: 'auto',
  backgroundPosition: '189px 3px',
};

export const handleAddToActiveCart = async (order_id, push, locale) => {
  const res = await activeCart(order_id);
  const cart_id = res?.data?.data?.cart_id;

  if (cart_id) {
    setCookie('quote', cart_id);
    setTimeout(() => {
      push(`/${locale}/cart`);
    }, 200);
  }
};

export const getErrorMessage = (payment, reason, locale) => {
  if (payment === 'tabby') {
    if (reason === 'Failure') {
      return locale?.includes('en')
        ? 'Sorry, Tabby is unable to approve this purchase. Please use an alternative payment method for your order.'
        : 'نأسف، تابي غير قادرة على الموافقة على هذه العملية. الرجاء استخدام طريقة دفع أخرى.';
    }
    return locale?.includes('en')
      ? 'You aborted the payment. Please retry or choose another payment method.'
      : 'لقد ألغيت الدفعة. فضلاً حاول مجددًا أو اختر طريقة دفع أخرى.';
  }
  return locale?.includes('en')
    ? 'Payment Failed, Please try again'
    : 'فشلت عملية الدفع, برجاء المحاولة مره اخرى';
};

export function unescapeHtml(escapedHtml) {
  const htmlEntities = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
  };

  return escapedHtml
    ?.replace(/&amp;|&lt;|&gt;|&quot;|&#39;/g, (match) => htmlEntities[match])
    ?.replaceAll(
      '"{{media url="',
      `${process.env.NEXT_PUBLIC_IMG_BASEURL}/media/`
    )
    ?.replaceAll(`/media/" `, '/media/')
    ?.replaceAll('"}}"', '')
    ?.replaceAll(
      '{{media url=',
      `${process.env.NEXT_PUBLIC_IMG_BASEURL}/media/`
    )
    ?.replaceAll('}}', '');
}

export function colorNameToHex(colorName) {
  if (colorName) {
    // Check if input is already a valid hex color
    const hexPattern = /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i;
    if (hexPattern.test(colorName)) {
      return colorName.toLowerCase();
    }
  
    // Create temporary element to get computed style
    const temp = document.createElement('div');
    temp.style.color = colorName;
    document.body.appendChild(temp);
  
    const rgb = getComputedStyle(temp).color;
    document.body.removeChild(temp);
  
    const match = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
    if (!match) return null;
  
    let [r, g, b] = match.slice(1, 4).map(Number);
  
    const toHex = (n) => n.toString(16).padStart(2, '0');
    const hex = `#${toHex(r)}${toHex(g)}${toHex(b)}`.toLowerCase();
  
    // Try compressing to shorthand (e.g. "#ff0000" => "#f00")
    if (
      hex[1] === hex[2] &&
      hex[3] === hex[4] &&
      hex[5] === hex[6]
    ) {
      return `#${hex[1]}${hex[3]}${hex[5]}`;
    }
  
    return hex;
  }
}